module.exports = __webpack_public_path__ + "static/media/f7.9e78564b.png";